import { render, staticRenderFns } from "./LearningGroupTableItem.vue?vue&type=template&id=76c5a30d&"
import script from "./LearningGroupTableItem.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports